var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      attrs: { id: "preferred-login-onboard" },
    },
    [
      _c("h3", [_vm._v("Peppermill Preferred")]),
      _vm._v(" "),
      _vm.preferredRateDifference.length
        ? _c("p", [
            _vm._v("Membership is free, save "),
            _c("strong", [_vm._v(_vm._s(_vm.preferredRateDifference))]),
            _vm._v(" on your stay!"),
          ])
        : _c("p", [
            _vm._v("Membership is free, and saves you money on your stay!"),
          ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "pepvalidate-v3 full-width signup-preferred",
          attrs: {
            action: _vm.apiUrl,
            "data-preferred-callback": "BOOKING-PREFERRED-ENROLL-SUCCESS",
            method: "post",
          },
        },
        [
          _c("p", { staticClass: "full-width" }, [
            _vm._v(
              "Signup or login here, it's easy and only requires your email address."
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "full-width" }, [
            _c("label", [
              _c("span", { staticClass: "text" }, [_vm._v("Email Address")]),
              _vm._v(" "),
              _c("input", {
                staticClass: "required",
                attrs: {
                  "data-error-msg": "Please enter a valid email address.",
                  "data-regex": _vm.dataRegex,
                  name: "EMAIL",
                  type: "text",
                },
                on: { keydown: _vm.checkKeyDown },
              }),
            ]),
          ]),
          _vm._v(" "),
          _vm.disclaimerCopy.length
            ? _c("p", { staticClass: "hidden" }, [_vm._v(" ")])
            : _vm._e(),
          _vm._v(" "),
          _vm.disclaimerCopy.length
            ? _c("p", { staticClass: "full-width disclaimer" }, [
                _vm._v("\n      " + _vm._s(_vm.disclaimerCopy) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "hidden" }, [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", { staticClass: "submit-wrapper full-width" }, [
            _c("input", {
              attrs: { type: "submit", value: "SIGN UP / LOGIN NOW" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.submitForm.apply(null, arguments)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("input", {
            staticClass: "honey",
            attrs: { name: "alasMK43kyM3khm5km5h", type: "text", value: "" },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: {
              name: "ACTION",
              type: "hidden",
              value: "PEPPERMILL_PREFERRED_ENROLL",
            },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "LOGIN_IF_FOUND", type: "hidden", value: "YES" },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "FIRST_NAME", type: "hidden", value: "" },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "LAST_NAME", type: "hidden", value: "" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "h2",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show",
            },
          ],
        },
        [_vm._v("OR")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }